<ng-container *ngIf="!loading; else displayLoader">
    <ng-container *ngIf="user">
        <div>
            <app-address-list
                [isProfile]="true"
                [companyId]="companyId"
                [companyRoleMap]="companyRoleMap"
                (roleUpdated)="onRoleUpdated()"
            ></app-address-list>
        </div>
    </ng-container>
</ng-container>
<ng-template #displayLoader>
    <div class="text-center py-4">
        <app-loader></app-loader>
    </div>
</ng-template>
